import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

interface Props {
  label: string | React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export default function (props: Props) {
  const { label, children, className } = props;

  return (
    <div className={cn(styles.input_item, className)}>
      <div
        className={typeof label === 'string' ? styles.input_label : undefined}
      >
        {label}
      </div>
      <div className={styles.input_content}>{children}</div>
    </div>
  );
}
